import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import axios from 'src/utils/axios';
import { Grid, Button, Snackbar, MenuItem, Tooltip, IconButton, Box, Select, InputLabel, FormControl, Backdrop, CircularProgress, CardHeader, CardContent, Divider, TextField, Container, Chip } from '@mui/material';
import Card from '@mui/material/Card';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import moment from 'moment';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

function SarisDynamicOther() {
  const navigate = useNavigate();
  const [dynamicTypes,setDynamicTypes] = React.useState([]);
  const [dynamicOtherGeneralData,setDynamicOtherGeneralData] = React.useState([]);
  const [definitionCode, setDefinitionCode] = React.useState([]);
  const [
    definitionCodeDescription,
    setDefinitionCodeDescription
  ] = React.useState([]);
  const [type, setType] = React.useState(6);

  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    getDynamicTypes();
    getDynamicOtherData();
  }, []);

  const getDynamicOtherData = () => {
    setLoading(true);
    axios.get('/GetDynamicOther').then(response => {
      const data = response.data;
      setDynamicOtherGeneralData(Array.isArray(data) ? data : []);
      setLoading(false);
    });
  };

   const getDynamicTypes = () => {
    setLoading(true);
    axios.get('/GetDynamicTypes').then(response => {
      const data = response.data;
      setDynamicTypes(Array.isArray(data) ? data : []);
      setLoading(false);
    });
  };

  const handleDeleteSelectedRow = (ElCode, ElType) => {
    confirmAlert({
      message: 'Seçilen satırı silmek istediğinize emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            deleteSelectedRows(ElCode, ElType);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const deleteSelectedRows = (ElCode, ElType) => {
    const data = {
      ElCode: ElCode,
      ElType: ElType
    };
    setLoading(true);

    axios
      .post('/SetSarisDynamicServiceLaborMaterialDelete', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.ErrorCode == 0) {
          setresponseMessage('Silme İşlemi başarıyla gerçekleşmiştir.');
          setUyariTip('success');
          getDynamicOtherData();
        } else {
          setresponseMessage(response.data.ErrorDescription);
          setUyariTip('error');
        }
        setLoading(false);
        setUyari(true);
      });
  };

  const handleCreateNewServiceLaborMaterial = () => {
    const data = {
      KulElCode: definitionCode,
      ElType: type,
      Description: definitionCodeDescription
    };
    setLoading(true);
    axios
      .post('/SetSarisDynamicCreateNewServiceLaborMaterial', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.ErrorCode == 0) {
          setresponseMessage('Ekleme İşlemi başarıyla gerçekleşmiştir.');
          setUyariTip('success');
          getDynamicOtherData();
        } else {
          setresponseMessage(response.data.ErrorDescription);
          setUyariTip('error');
        }
        setLoading(false);
        setUyari(true);
      });
    setLoading(false);

    //Temizleme İşlemi
    setDefinitionCode([]);
    setDefinitionCodeDescription([]);
    setType([]);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleRouteDetailPage = (
    UserCode,
    ElType,
    ElCode,
    UserElCode,
    Description
  ) => {
    navigate(
      `/SarisDesc/OtherDynamicDetaill/${UserCode}/${ElType}/${ElCode}/${UserElCode}/${Description}`
    );
  };

  const columns = [
    {
      field: 'KUL_EL1_KODU',
      headerName: 'Kod',
      width: 300,
      headerAlign: 'center',
      align: 'center',
      renderCell: params => (
        <Chip
          label={params.row.KUL_EL1_KODU}
          size="small"
          variant="outlined"
          clickable
          onClick={() => {
            handleRouteDetailPage(
              params.row.KUL_KODU,
              params.row.EL1_TIP_KODU,
              params.row.EL1_KODU,
              params.row.KUL_EL1_KODU,
              params.row.ACIKLAMA
            );
          }}
        />
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 600,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'EL1_TIPI',
      headerName: 'Tip',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'KULLANICI',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return params.value
          ? moment(params.value).format('DD/MM/YYYY HH:mm:ss')
          : 'Geçerli Tarih Yok';
      }
    },
    {
      field: 'Sil',
      headerName: '',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: cellValues => {
        return (
          <Tooltip title="Sil">
            <IconButton
              size="small"
              onClick={() =>
                handleDeleteSelectedRow(
                  cellValues?.row?.EL1_KODU,
                  cellValues?.row?.EL1_TIP_KODU
                )
              }
            >
              <DeleteIcon style={{ color: '#FF9800' }} />
            </IconButton>
          </Tooltip>
        );
      },
      width: 80
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <CardHeader title="Diğer Dinamik Tanımlar" />
        <Divider />
        <CardContent>
          <Container maxWidth="sm">
            <Grid container spacing={2}>
              <Grid size={12}>
                <TextField
                  label="Tanım Kodu"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={definitionCode}
                  onChange={e => {
                    setDefinitionCode(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="GrupTipi">Grup Tipi</InputLabel>
                  <Select
                    labelId="GrupTipi"
                    label="Grup Tipi"
                    variant="outlined"
                    value={type}
                    onChange={e => setType(e.target.value)}
                    fullWidth
                  >
                    {dynamicTypes ? dynamicTypes.map(item => (
                      <MenuItem key={item.EL1_TIPI} value={item.EL1_TIPI}>{item.ACIKLAMA}</MenuItem>
                    )) : <></>}
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={12}>
                <TextField
                  label="Tanım Açıklaması"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={definitionCodeDescription}
                  onChange={e => {
                    setDefinitionCodeDescription(e.target.value);
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={() => {
                      handleCreateNewServiceLaborMaterial();
                    }}
                  >
                    Ekle
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Container>
          <Box sx={{ mt: 3, height: 600, width: '100%' }}>
            <DataGrid
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  color: 'text.primary'
                },
                '& .MuiDataGrid-cell': {
                  color: 'text.primary'
                }
              }}
              rows={dynamicOtherGeneralData}
              columns={columns}
              getRowId={rows => rows.EL1_KODU}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 }
                }
              }}
              pageSizeOptions={[10, 25, 50]}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { placeholder: 'Ara...' }
                }
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicOther;
